document.addEventListener("DOMContentLoaded", function () {
  const hotspots = document.querySelectorAll(".hotspot");

  hotspots.forEach(hotspot => {
    hotspot.addEventListener("click", function (e) {
      const id = this.dataset.target;
      const box = document.getElementById(id);
      const visible = box.style.display === "block";

      // Hide all other boxes
      document.querySelectorAll(".hotspot-box").forEach(el => el.style.display = "none");

      // Toggle current
      if (!visible) {
        box.style.display = "block";
      }
    });
  });

  // Hide boxes when clicking outside
  document.addEventListener("click", function (e) {
    const isHotspot = e.target.classList.contains("hotspot");
    const isBox = e.target.closest(".hotspot-box");

    if (!isHotspot && !isBox) {
      document.querySelectorAll(".hotspot-box").forEach(el => el.style.display = "none");
    }
  });
});